export default {
  getGoodsList: '/wdsx-shop/goods/getAllGoods',
  getSupplierList: '/wdsx-shop/supplier/queryAll',
  getOneGoodsTypeList: '/wdsx-shop/goodsType/getShopOneGoodsTypeListPage',
  enSaleOrUnSale: '/wdsx-shop/goods/enSaleOrUnSale',
  batchDeleteGoods: '/wdsx-shop/goods/deleteGoodsByIds',
  getNextGoodsType: '/wdsx-shop/goodsType/getShopNextGoodsTypePage',
  saveOrUpdateGoods: '/wdsx-shop/goods/saveOrUpdateGoods',
  getBaseTypes: '/wdsx-shop/goodsBaseType/getAllBaseTypeList',
  getSpecListByGoodsTypeId: '/wdsx-shop/goodsspecification/getSpecListByGoodsTypeId',
  getBaseAttributeList: '/wdsx-shop/goodsBaseAttribute/getTwoBaseAttributeByGoodsTypeId',
  getGoodsById: '/wdsx-shop/goods/getGoodsMoById',
  getGoodsNum: '/wdsx-shop/product/getProductNumById',
  setBannerClick: '/wdsx-shop/homePageBanner/addClicks',
  setSupplierClick: '/wdsx-shop/supplier/addClicks',
  setGoodsClick: '/wdsx-shop/goods/addClicks',
  getGoodsByName: '/wdsx-shop/goods/getGoodsByNameAndIntro',
  getGoodsCode: '/wdsx-shop/goods/getGoodsCode',
  getEvaluateByGoodsId: '/wdsx-shop/productEvaluate/getEvaluateByGoodsId',
  getSupplierTelePhone: '/wdsx-shop/supplier/getSupplierTelePhoneByGoodsId'
};
